<template>
	<div 
		class="search-records fine-scroll-bar"
		v-infinite-scroll="loadSearchRecords"
		:infinite-scroll-distance="1"
		:infinite-scroll-disabled="isFinalPage"
	>
		<ul class="search-records-ul">
			<li 
				v-for="item in searchRecordList"
				:key="item.id"
				class="search-records-li"
				@click="fastSearch(item.searchCondition)"
			>
				<div class="search-record-t">
					<span class="search-record-t-title">{{ item.name | noText }}</span>
					<!-- 操作 -->
					<RecordsOperate
						@rename="renameEmit(item.id, item.name)"
						@delete="deleteEmit(item.id)"
					>
						<span @click.stop="()=>{}" class="search-record-t-operate iconfont icon-icon-gengduo"></span>
					</RecordsOperate>
				</div>
				<p class="search-record-c">{{ item.searchTime | handleFormatDateAndTimeNoYear }}</p>
				<ul class="search-record-b">
					<li 
						v-for="(tag, i) in item.tags"
						:key="i"
						class="search-record-b-item"
					>{{ tag }}</li>
				</ul>
			</li>
			<li v-if="searchRecordsLoading" class="search-records-loading" v-loading="true"></li>
			<li v-if="isFinalPage && searchRecordList.length >= 10" class="search-records-loading">到底了~</li>
		</ul>
	</div>
</template>

<script>
import RecordsOperate from "@/components/overseas-buyer/recordsOperate.vue"
import {buyerSearchHistory, deleteBuyerSearchRecord} from "@/utils/api/seamark"

export default {
	name: 'search-records-list',
	components: {
    RecordsOperate,
},
	data() {
		return {
			searchRecordsLoading: true,  //搜索记录时的loading
			searchRecordList: [],	//搜索记录
			finalId: null,
			isFinalPage: false,	//是否最后一页，禁用滚动加载
		}
	},
	methods: {
		loadSearchRecords() {
      console.log('触底了')
			if(this.searchRecordsLoading) return;
			this.searchRecordsLoading = true;
			this.buyerSearchHistory();
    },
		async buyerSearchHistory() {
			const params = {
				type: 2,	// 1搜索历史 2被保存的搜索
				id: this.finalId, //向下滚动: id取上次结果的最后一条id;  向上滚动: id取上次结果的第一条。(第1页就为空)
				pageSize: 10,	//接口默认10
			}
			try {
				const res = await buyerSearchHistory(params);
				this.searchRecordsLoading = false;
				if(res.rspResult.bizCode==200){
					const _list = res.rspListData.list || [];
					if(params.id) {
						// 表示非第一页
						this.searchRecordList = this.searchRecordList.concat(_list);
					}else {
						// 第一页
						this.searchRecordList = _list;
					}
					if(_list && _list.length) {
						this.finalId = _list[_list.length - 1].id;
					}else {
						this.isFinalPage = true;
					}
				}else{
					this.isFinalPage = true;
					this.$message.error(res.rspResult.message);
				}
			} catch (err) {
				this.searchRecordsLoading = false;
				console.log('获取海外采购搜索记录的保存出错', err)
			}

		},
		async deleteBuyerSearchRecord(_id) {
			const params = {
				id: _id,
			}
			try {
				const res = await deleteBuyerSearchRecord(params);
				this.searchRecordsLoading = false;
				if(res.rspResult.bizCode==200){
					this.reloadFn();	//重新加载
					this.$message.success(res.rspResult.message);
				}else{
					this.$message.error(res.rspResult.message);
				}
			} catch (err) {
				this.searchRecordsLoading = false;
				console.log('获取海外采购搜索条件记录的保存出错', err)
			}
		},
		fastSearch(condition) {
			this.$emit('fastSearch', condition)
		},
		renameEmit(id, name) {
			this.$emit('rename', id, name);
		},
		deleteEmit(id) {
			this.$confirm('确定删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.deleteBuyerSearchRecord(id);
			}).catch(() => {});
		},
		reloadFn() {
			this.searchRecordsLoading = true;
			this.finalId = null;
			this.buyerSearchHistory();
		},
	},
	created() {
		this.buyerSearchHistory();
	},
}
</script>

<style lang="scss" scoped>
// 搜索记录
.search-records {
	flex: 1;
	height: 0;
	overflow-y: auto;
	margin: 10px 0;
	&::-webkit-scrollbar {
		width: 3px !important;
		display: none;
	}
	&:hover {
		&::-webkit-scrollbar {
			display: block;
		} 
	}
	&-ul {
		width: 218px;
		.search-records-li {
			width: 218px;
			box-sizing: border-box;
			padding: 14px 16px 11px;
			// height: 110px;
			background: #FFFFFF;
			border: 1px solid #CFD5DF;
			border-radius: 4px;
			margin-bottom: 16px;
			cursor: pointer;
			&:hover {
				border: 1px solid #AFB5BF;
			}
			.search-record-t {
				display: flex;
				justify-content: space-between;
				// height: 18px;
				line-height: 18px;
				margin-bottom: 4px;
				&-title {
					max-width: 168px;
					min-height: 18px;
					font-family: SourceHanSansCN-Regular;
					font-weight: 400;
					font-size: 14px;
					color: #16181A;
					// overflow: hidden;
					// white-space: nowrap;
					// text-overflow: ellipsis;
				}
				&-operate {
					user-select: none;
					margin-left: auto;
					color: #98A3B7;
					cursor: pointer;
				}
			}
			.search-record-c {
				height: 12px;
				line-height: 12px;
				font-family: SourceHanSansCN-Regular;
				font-weight: 400;
				font-size: 12px;
				color: #4F5D78;
				margin-bottom: 20px;
			}
			.search-record-b {
				display: flex;
				flex-wrap: wrap;
				user-select: none;
				&-item {
					padding: 2px 16px;
					min-height: 24px;
					line-height: 24px;
					background: #F5F7FA;
					border-radius: 4px;
					font-family: SourceHanSansCN-Regular;
					font-weight: 400;
					font-size: 14px;
					color: #16181A;
					margin-bottom: 5px;
					margin-right: 8px;
					word-break: break-word;
					&:nth-last-child(1) {
						margin-right: 0;
					}
				}
			}
			&:nth-last-child(2) {
				// margin-bottom: 0;
			}
		}
		
	}
}
// 加载更多
::v-deep .search-records-loading {
	line-height: 30px;
	font-family: SourceHanSansCN-Regular;
	font-size: 14px;
	color: #4F5D78;
	text-align: center;

	height: 30px;
	margin-top: 10px;
	.el-loading-mask {
		overflow: hidden;
		.el-loading-spinner {
			margin-top: 0;
			top: 0;
			height: 30px;
			.circular {
				width: 30px;
				height: 30px;
			}
		}
	}
}
</style>